import React, { useState, useMemo, useCallback, useEffect, useRef } from 'react'

import Modal from '@Modal/V3/Modal'

import FormStatus from '@/Form/FormStatus'

import Message from '@Pure/Message'
import Loader  from '@Pure/Loader'

import request from '@function/ajax/request'
import bemit   from '@function/bemit'

import { num, formatNum } from '@root/utility'

const { app, moment } = window;

export default function ECUsersAbondementsModal ({ onClose, onSuccess, ...props })
{
	const [status, setStatus] = useState({ });
	const [loading, setLoading] = useState(false);

	const _ref_ctrl = useRef();
	const _ref_busy = useRef();

// réinitialise la modale une fois masquée pour éviter
// de modifier ce qui est affiché en pleine animation d'ouverture/fermeture
	const handleModalHidden = useCallback(function (params)
	{
		setStatus({ });
	},
	[]);

	const modifiers = useMemo(function ()
	{
		return props.bemit || ['small'];
	},
	[props.bemit]);

	const prevent_close = loading === 'creating';

	const validate = useCallback(function ()
	{
		if (_ref_busy.current) return;
		_ref_busy.current = true;

		setLoading('creating');

		setStatus({ });

		const controller = new AbortController();
		_ref_ctrl.current = controller;

		(async function update ()
		{
			try
			{
				var response = await request('/abondement/update-users')
				.config({ controller })
				.post(
				{
					users: props.selected,
					value: props.value,
					type: props.type,
					v2: true
				});
			}
			catch (update)
			{
				return setStatus(update);
			}
			finally
			{
				_ref_busy.current = false;
				setLoading(false);
			}

			app.state.session.EC.abondement = response.session_abondement;
			app.state.session.abondement    = response.session_abondement;

			app.emit('sessionChange');

			setStatus(response);

			if (typeof onSuccess === 'function') onSuccess(response);

			onClose();
		})();

		return () => { _ref_ctrl.current?.abort?.(); _ref_busy.current = false; };
	},
	[onSuccess, props.selected, props.type, props.value, onClose]);

	const footer =
	(
		<>
			<FormStatus { ...status } />

			{
				status?.info ? undefined :
				(
					<button type="button" aria-label="Fermer"
						className={ bemit('c-btn', ['green']) }
						onClick={ validate }>
						Mettre à jour
					</button>
				)
			}

			<button type="button" aria-label="Fermer"
				className={ props['close-classes'] || bemit('c-btn', ['grey']) }
				onClick={ exit }>
				Fermer
			</button>

			{
				loading ?
				(
					<Loader className="c-loader" bemit={ ['primary', 'bg-white'] }
						label="Mise à jour..."
					/>
				)
				: undefined
			}

		</>
	);

	const content = status?.info ? undefined
	: !props.selected?.length || !props.value ?
	(
		<Message color="red">
			Veuillez saisir un montant positif.
		</Message>
	)
	:
	(
		<Message color="orange">
			Vous allez
			{ ' ' }
			{ props.type === 'sub' ? 'soustraire' : 'ajouter' }
			{ ' ' }
			<strong>
				{ formatNum(props.value, '0,0[.]00') + ' €' }
			</strong>
			{ ' à ' }
			{ props.selected.length }
			{ ' membre' }
			{ props.selected.length > 1 ? 's' : '' }
			. Continuer&nbsp;?
		</Message>
	);

	return (
		<Modal open={ props.open === true } onClose={ onClose }
			bemit={ modifiers } trg={ props.trg } footer={ footer }
			title="Confirmation de modification"
			prevent-close={ prevent_close }
			afterHidden={ handleModalHidden }>

			{ content }

			<div className="u-margin-top-5" />

		</Modal>
	);

	function exit (e)
	{
		_ref_ctrl.current?.abort?.();
		onClose(e);
	}
}